import { createContext, useContext } from 'react'
import { useStore } from 'zustand'
import { SearchStoreType } from './initialise-search-store'
import type { SearchFiltersState } from '@cinch-nx/data-search'

export const SearchStoreContext = createContext<SearchStoreType | null>(null)

export const useSearchStore = <T>(
  selector: (state: SearchFiltersState) => T,
) => {
  const store = useContext(SearchStoreContext)

  if (!store) throw new Error('Store is missing the provider')

  return useStore(store, selector)
}
